import {AssetApiDto} from "./restModels";

export default class Asset {
    constructor(public readonly id: number, public readonly name: string) {}

    public static fromJson(json: AssetApiDto): Asset {
        return new Asset(json.id, json.name);
    }
}